module.exports = __webpack_public_path__ + "static/media/44606628_2199885396753306_3235585811118292992_o-thumb.66802ee7.jpg";